import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import React from "react";

export default function ServiceTypeSelect(
    {
        isNonEditable,
        handleServiceTypeUpdate,
        currentServiceType,
        currentServiceTypeKeycode,
        availableServiceTypes
    }
) {

    return <>
        {
            (() => {
                if (isNonEditable) {
                    return <TextField
                        id='service-type-select'
                        label='Service Type'
                        value={currentServiceType}
                        variant='standard'
                        slotProps={{input: {readOnly: true}}} />;
                } else {
                    return <FormControl fullWidth style={{minWidth: 120}}>
                        <InputLabel id="service-type-select-label">Service Type</InputLabel>
                        <Select
                            labelId='service-type-select-label'
                            id='service-type-select'
                            label='Service Type'
                            onChange={e => handleServiceTypeUpdate(e.target.value)}
                            value={currentServiceTypeKeycode}
                            MenuProps={{MenuListProps: {sx: {paddingBottom: 0}}}}
                        >
                            {
                                availableServiceTypes.map(type => {
                                    return <MenuItem key={type.keycode}
                                                     value={type.keycode}>{type.description}</MenuItem>;
                                })
                            }
                        </Select>
                    </FormControl>;
                }
            })()
        }
    </>;
}